// app/javascript/turbo_stream_actions.js
import { StreamActions } from "@hotwired/turbo"

StreamActions.fade_out_and_remove = function() {
    const element = this.targetElements[0]
    if (element) {
        element.classList.add('removing')
        setTimeout(() => {
            element.remove()
        }, 300) // Match the CSS transition duration
    }
}

/*
StreamActions.refresh_affirmSS = function () {
    if (window.affirm && window.affirm.ui && typeof window.affirm.ui.refresh === "function") {
        window.affirm.ui.ready(() => window.affirm.ui.refresh())
    }
}
*/
